import React from 'react';
import { AlertTriangle } from 'lucide-react';

export default function RiskMisinterpretation({risk}:any) {
  const data = risk?.risk_impact_guardrails
  const stakeHolder = risk?.stakeholder_perspectives
    // const coreRisks = risk?.core_risks || [];
  return (
    <div className="w-full">
      {/* Header */}
      <div className="text-center mb-3">
        <h1 className="relative inline-block text-white text-center font-extrabold 
  max-w-4xl text-2xl lg:text-4xl font-nunito mb-2 
  bg-gradient-to-r from-[#92D050] to-[#8CC54F] 
  px-6 py-2
  before:content-[''] before:absolute before:left-0 before:top-1/2 
  before:-translate-y-1/2 before:-translate-x-full
  before:border-y-[16px] before:border-r-[16px] before:border-y-transparent 
  before:border-r-[#92D050]

  after:content-[''] after:absolute after:right-0 after:top-1/2 
  after:-translate-y-1/2 after:translate-x-full
  after:border-y-[16px] after:border-l-[16px] after:border-y-transparent 
  after:border-l-[#8CC54F]">
          Risks, Misinterpretations & Guardrails
        </h1>
      </div>

      

      {/* Main Content Grid */}
      <div className=" gap-4 mb-3 flex items-center">
        {/* Three Core Risks */}
         <div className="space-y-1">
            <h3 className="text-center font-bold text-gray-800 text-sm mb-3">
              Three Core Risks
            </h3>

             <div className="space-y-1 border-2 border-green-800 rounded-lg p-1">
            {risk.core_risks.map((item:any)=>(
              <div key={item.index} className="bg-lime-500 p-1 rounded text-xs text-gray-800">
             {item}
            </div>
            ))}
          </div>
          
          </div>

        {/* Underlying Drivers */}
        <div className="">
          <h3 className="text-center font-bold text-gray-800 text-sm mb-3">
            Underlying Drivers
          </h3>
          <div className="space-y-1 border-2 border-green-800 rounded-lg p-1">
            {risk.underlying_drivers.map((item:any)=>(
              <div key={item.index} className="bg-lime-500 p-1 rounded text-xs text-gray-800">
             {item}
            </div>
            ))}
          </div>
        </div>

        {/* Clinical & Emotional Impact (Risks) */}
        <div className=''>
            <div className="text-center font-bold text-gray-800 mb-3">
                Risk → Impact → Guardrail
            </div>
            <div className="flex space-x-2">
      {/* Risks Column */}
      <div className="space-y-2 flex-1">
        <h3 className="text-center font-bold text-white bg-lime-600 p-2 rounded-t-lg text-sm">
          Risks
        </h3>
        <div className="space-y-2">
          {data?.map((item:any, index:any) => (
            <div
              key={index}
              className="bg-lime-500 p-2 rounded text-xs text-gray-800 font-medium"
            >
              {item.risk}
            </div>
          ))}
        </div>
      </div>

      {/* Clinical & Emotional Impact Column */}
      <div className="space-y-2 flex-1">
        <h3 className="text-center font-bold text-white bg-lime-600 p-2 rounded-t-lg text-sm">
          Clinical & Emotional Impact
        </h3>
        <div className="space-y-2">
          {data?.map((item:any, index:any) => (
            <div
              key={index}
              className="bg-lime-500 p-2 rounded text-xs text-gray-800 font-medium"
            >
              {item.clinical_emotional_impact}
            </div>
          ))}
        </div>
      </div>

      {/* Guardrails Column */}
      <div className="space-y-2 flex-1">
        <h3 className="text-center font-bold text-white bg-lime-600 p-2 rounded-t-lg text-sm">
          Guardrails
        </h3>
        <div className="space-y-2">
          {data?.map((item:any, index:any) => (
            <div
              key={index}
              className="bg-lime-500 p-2 rounded text-xs text-gray-800 font-medium"
            >
              {item.guardrail}
            </div>
          ))}
        </div>
      </div>
    </div>
        </div>
        
      </div>

      {/* HCP Section */}
      <div className='flex justify-between w-full'>
        <div className="mb-6">
          <h3 className="text-center font-bold text-gray-800 text-sm mb-3">
            Critical Misinterpretation Patterns
          </h3>
          <div className="border-2 border-green-800 rounded-lg p-1 space-y-1">
            {(risk?.critical_misinterpretation_patterns || []).map(
              (item: { pattern: string }, index: number) => (
                <div
                  key={index}
                  className="bg-lime-500 p-2 rounded text-xs text-gray-800 text-center font-medium"
                >
                  {item.pattern}
                </div>
              )
            )}
          </div>
        </div>



         <div className="border-2 border-gray-400 rounded-lg p-1 bg-gray-50 space-y-2">
          {stakeHolder.map((item:any)=>(
            <>
             <div className="flex items-center mb-1">
                <h3 className="font-bold text-gray-800 text-sm">{item.stakeholder}</h3>
            </div>
            <div className="space-y-2">
                <div className="bg-lime-400 p-1 rounded text-xs text-gray-800 flex items-center">
                    <span className="font-semibold mr-2">{item.perspective}</span>
                </div>
            </div>
            </>
          ))}
            
        </div>
      </div>
    </div>
  );
}